module.exports = __webpack_public_path__ + "347880edac55411ab6fd16ef88c1f404.png";